import { Box, Typography } from "@mui/material";
import React from "react";
import { useFallbackIcon } from "../ui/useFallbackIcon";

interface IntegrationCardIconProps {
  icon?: string | string[] | null;
  alt: string;
  fallbackText?: string;
  hideOnError?: boolean;
}

export const IntegrationCardIcon: React.FC<IntegrationCardIconProps> = ({
  icon,
  alt,
  fallbackText,
  hideOnError = false,
}) => {
  const { activeIcon, isVisible, handleError } = useFallbackIcon(icon);

  if (!activeIcon || !isVisible) {
    if (hideOnError || !fallbackText) {
      return null;
    }

    return (
      <Box
        sx={{
          width: 40,
          height: 40,
          bgcolor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          border: "1px solid rgba(224, 224, 224, 1)",
        }}
      >
        <Typography variant="h6" color="text.secondary">
          {fallbackText}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 40,
        height: 40,
        bgcolor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "10px",
        padding: "5px",
        border: "1px solid rgba(224, 224, 224, 1)",
      }}
    >
      <img
        src={activeIcon}
        alt={alt}
        className="w-full h-full object-contain"
        onError={handleError}
      />
    </Box>
  );
};
